import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconCubeInterpretationSizeS from './IconCubeInterpretation_size_s';

const props: CreateIconArguments = {
  l: IconCubeInterpretationSizeS,
  m: IconCubeInterpretationSizeS,
  s: IconCubeInterpretationSizeS,
  xs: IconCubeInterpretationSizeS,
  name: 'IconCubeInterpretation',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
